import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addMessage, updateMessage, deleteMessage } from "../../../../shared/store/redux/entities-action";
import { gradesList } from "../../../../shared/enums/gradesEnum";
import MessageEditorPopup from "../../../../shared/components/features/message/messageEditorPopup/MessageEditorPopup";
import ConfirmDeletePopup from "../../../../shared/components/features/message/confirmDeletePopup/ConfirmDeletePopup";
import actionType from "../../../../shared/enums/actionType";
import targetGroupType, { targetGroupTextType } from "../../../../shared/enums/targetGroupType";
import boardType from "../../../../shared/enums/boardType";

const SystemMessagesEditorFlow = ({ type, draft, onDraftChange, onClose, onSaved }) => {

    const { texts } = useSelector(state => state.translate);
    const schoolId = useSelector(state => state.auth.userDetails?.defaultSchool?.id);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const dispatch = useDispatch();

    const buildFilters = (targetAudience, selectedGrades) => {
        const isTeacher = targetAudience === targetGroupTextType.Teacher || targetAudience === targetGroupTextType.Everyone;
        const isStudent = targetAudience === targetGroupTextType.Student || targetAudience === targetGroupTextType.Everyone;
        const filters = [];

        if (isTeacher && isStudent && selectedGrades.length === gradesList.length)
            return [{ schoolId, targetGroup: targetGroupType.Everyone }];
        if (isTeacher)
            filters.push({ schoolId, targetGroup: targetGroupType.Teacher });
        if (isStudent && selectedGrades.length === gradesList.length)
            filters.push({ schoolId, targetGroup: targetGroupType.Student });
        else if (isStudent)
            selectedGrades.forEach(g => filters.push({ schoolId, targetGroup: targetGroupType.Student, grade: g.value }));
        return filters;
    };

    const handlePublish = async () => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        try {
            const payload = {
                id: draft.id,
                boardId: boardType.dashboardMessages,
                fromDate: draft.fromDate,
                toDate: draft.toDate,
                important: draft.isImportant,
                tags: ["school", "user"],
                messageContents: [
                    { lang: "", content: draft.content, imageFile: draft.imageFile },
                ],
                messageFilters: buildFilters(draft.targetAudience, draft.selectedGrades),
            };
            const res = await dispatch(type === actionType.add ? addMessage(payload) : updateMessage(payload));
            if (res?.ok) onSaved();
        } catch (e) {
            console.error("SystemMessagesEditorFlow publish", e);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleDelete = async () => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        try {
            const res = await dispatch(deleteMessage(draft));
            if (res?.ok) onSaved();
        } catch (e) {
            console.error("SystemMessagesEditorFlow delete", e);
        } finally {
            setIsSubmitting(false);
        }
    };

    return type === actionType.delete
        ? <ConfirmDeletePopup
            onClose={onClose}
            onClick={handleDelete}
            isSubmitting={isSubmitting}
            text={texts.deleteMessagePermanentBody}
            confirmText={texts.deleteMessagePermanentBodyTitle}
        />
        : (
            <MessageEditorPopup
                titleText={type === actionType.add ? texts.newMessage : texts.editMessage}
                publishText={type === actionType.add ? texts.publishMessageBtn : texts.keep}
                draft={draft}
                onDraftChange={onDraftChange}
                onClose={onClose}
                onPublish={handlePublish}
                isSubmitting={isSubmitting}
                popupHeight="auto"
                useAudienceField
                showImportant
            />
        );
};

export default SystemMessagesEditorFlow;
